import {h, Fragment} from "preact"
import { useAppStateSelector, useSort, useFacets, pick } from "@nosto/preact"
import { useMemo } from "preact/hooks"
import { useSidebarContext } from "../contexts/SidebarContext"
import { sortOptions, toggleFacets } from "../config"

import DesktopPopularFilters from "./facets/DesktopPopularFilters"
import FacetToggle from "./facets/FacetToggle"
import SortBy from "./SortBy"

export default function Toolbar() {
    const { loading, response, pageType, query } = useAppStateSelector(state =>
        pick(state, "loading", "response", "pageType", "query")
    )
    const { facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)
    const { sidebarOpen, toggleSidebar } = useSidebarContext()
    const docCount = response.products?.total ?? 0
    const options = useMemo(() => sortOptions.map(o => ({ value: o.id, label: o.value.name })), [sortOptions]);
    const quickShipFacet = useMemo(() => facets.find(f => f.name.toLowerCase() === "quick ship"), [facets])

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    return (
        <>
            {pageType === 'search' && query.query ? (
                <h1 class="h2 mb-sm lg:mb-lg px-pagemargin">
                    Search results for "{query.query}"
                </h1>
            ) : (
                null
            )}
            <div class="ns-toolbar flex justify-between w-full px-pagemargin py-sm sticky z-20 top-[var(--header-height)] transition-[top] ease-in-out duration-100 bg-t-background">
                <div class="flex gap-xs items-center">
                    <button
                        class="ns-sidebar-toggle btn flex gap-xs items-center !normal-case group-aria-expanded/drawer:!text-t-foreground text-sm !min-w-[90px] lg:!min-w-[110px] !px-xs !border bg-t-foreground border-t-border group-aria-expanded/drawer:bg-t-brand-primary-contrast group-aria-expanded/drawer:border-t-foreground"
                        variant="secondary"
                        type="button"
                        aria-controls="ns-sidebar"
                        aria-label={sidebarOpen? "Close filters" : "Open filters"}
                        aria-expanded={sidebarOpen}
                        onClick={toggleSidebar}
                    >
                        <span class="whitespace-nowrap">{sidebarOpen ? "Close Filter" : "Filter"}</span>
                        <span class="flex items-center justify-center" style="width: 18px; height: 18px;" aria-hidden="true" role="presentation" focusable="false">
                            <span class="block" style="width: 16px; height: 11px;">
                                <svg fill="none" class="icon icon-filter" viewBox="0 0 18 13">
                                    <g stroke="currentColor" stroke-linecap="square" stroke-linejoin="round" clip-path="url(#a)"><path d="M1 3h3m0 0a2 2 0 1 0 4 0M4 3a2 2 0 1 1 4 0m0 0h9M1 10h9m0 0a2 2 0 1 0 4 0m-4 0a2 2 0 1 1 4 0m0 0h3"></path></g>
                                </svg>
                            </span>
                        </span>
                    </button>

                    <DesktopPopularFilters />

                    {/* quick ship */}
                    {quickShipFacet &&
                        <FacetToggle 
                            facet={quickShipFacet} 
                            idPrefix={`ns-toolbar`} 
                            toggleData={toggleFacets.find(f => f.facetName.toLowerCase() === "quick ship")}
                        />
                    }
                </div>

                <div class="flex gap-xs items-center lg:ml-xs">
                    <div
                        class="caption text-sm text-t-foreground hidden sm:block whitespace-nowrap"
                        data-nosto-element="totalResults"
                    >
                        {docCount} Items
                    </div>
                    <SortBy />
                </div>
            </div>
        </>
    )
}
